import { Injectable } from '@angular/core';
import { Environment, EnvironmentService } from '@galaxy/core';
import { Observable } from 'rxjs';
import { CountryProviderDeterminant, MerchantProviderDeterminant, PaymentService } from './payment';

// Public API Key for Live Canadian Account
const CA_LIVE_API_KEY = 'pk_live_Nv6bm5YyuSb2cCj1Tv2laHeV';
// Public API Key for Test Canadian Account
const CA_TEST_API_KEY = 'pk_test_d7arUvYIZ2TNTwmyDQUCHqUB';

@Injectable({ providedIn: 'root' })
export class StripeService {
  private connectPublicKey: string;

  constructor(private environmentService: EnvironmentService, private paymentService: PaymentService) {
    this.connectPublicKey =
      this.environmentService.getEnvironment() === Environment.PROD ? CA_LIVE_API_KEY : CA_TEST_API_KEY;
  }

  // returns the public API key that is to be used for Stripe Connect Account requests, which is regardless of the merchant's subsidiary and is always corresponding to Vendasta's Canadian Stripe account.
  public getConnectPublicKey(): string {
    return this.connectPublicKey;
  }

  // returns the public API key that is associated to the corresponding merchant's susibidiary.
  public getPublicKeyByMerchant(merchantId: string): Observable<string> {
    return this.paymentService.getWholesaleProviderPublicKey(new MerchantProviderDeterminant(merchantId));
  }

  // returns the public API key that is associated to the corresponding susibidiary location.
  // this should ONLY be used in the event we do not have an existing merchant record (i.e. during platform signup)
  public getPublicKeyByCountry(countryCode: string): Observable<string> {
    return this.paymentService.getWholesaleProviderPublicKey(new CountryProviderDeterminant(countryCode));
  }
}
